import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * チェックボックス
 *【内容:content:string】
 *【チェックフラグ:checked:boolean】
 *【非活性:disabled:boolean】
 *【ラベル内容:labelContent:string】
 *【複数選択:indeterminate:boolean】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-checkbox-field',
  templateUrl: './checkbox-field.html',
  styles: [`
    .checkboxInput {
      margin:8px 16px;
    }
  `]
})
export class CheckboxField extends BaseWidget {
  /**
   * チェックフラグの表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * チェックフラグに対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * チェックフラグ
   */
  @Input() checked:boolean

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 複数選択
   */
  @Input() indeterminate:boolean

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  updateChecked(event:Event): boolean {
    const value = !!this.checked ? false : true
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
    return this.checked ? !this.checked : this.checked
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/checkbox/checkbox-field/checkbox-field.component.ts